import { useState } from "react"
import { Flex, Modal, message } from "antd"
import { Text } from "~/components/Text"
import { createStaffOrderOpLog } from "~/api/staff"
import { ApiRequestError } from "~/common/request"
import { BulkWalletEntryMode, OrderType } from "~/common/constants"
import { formatAmount } from "~/common/utils"
import {
  bulkEntryModeLabel,
  orderTypeLabel,
  paymentMethodLabel,
  productCodeLabel,
} from "./labels"
import { getBulkWalletAmount, getBulkWalletQuantity } from "./orderForm"

export const OrderConfirmationModal = ({
  payload,
  mobile,
  onSuccess,
  onCancel,
}: {
  payload: API.Staff.CreateStaffOrderOpLogParams
  mobile: string
  onSuccess: () => void
  onCancel: () => void
}) => {
  const [submitting, setSubmitting] = useState(false)
  const bulk =
    payload.order_type === OrderType.bulkWalletPackage ? payload : null
  const byAmount = bulk?.bulk_entry_mode === BulkWalletEntryMode.amount
  const amount = bulk
    ? byAmount
      ? bulk.amount
      : getBulkWalletAmount(
          bulk.wallet_recharge_amount,
          bulk.purchase_unit_price,
        )
    : undefined
  const quantity = byAmount
    ? getBulkWalletQuantity(amount, bulk?.purchase_unit_price)
    : payload.wallet_recharge_amount
  const submit = async () => {
    if (submitting) return
    setSubmitting(true)
    try {
      await createStaffOrderOpLog(payload)
      void message.success("支付订单已录入")
      onSuccess()
    } catch (error) {
      // 保留本次确认的参数及交易号，支持原样重试；业务错误由请求层统一提示。
      if (!(error instanceof ApiRequestError))
        void message.error("订单录入失败，请使用原交易号重试")
    } finally {
      setSubmitting(false)
    }
  }
  return (
    <Modal
      open
      title="确认录入支付订单"
      okText="确认录入"
      cancelText="取消"
      confirmLoading={submitting}
      cancelButtonProps={{ disabled: submitting }}
      closable={!submitting}
      keyboard={!submitting}
      maskClosable={!submitting}
      onCancel={onCancel}
      onOk={() => void submit()}
    >
      <Flex
        vertical
        gap={8}
      >
        <Text>被充值用户：{mobile}</Text>
        <Text>支付方式：{paymentMethodLabel[payload.payment_method]}</Text>
        <Text>订单类型：{orderTypeLabel[payload.order_type]}</Text>
        <Text>
          商品编码：
          {payload.product_code ? productCodeLabel[payload.product_code] : "-"}
        </Text>
        {quantity ? <Text>积点数量：{quantity}</Text> : null}
        {payload.order_type === OrderType.bulkWalletPackage ? (
          <>
            <Text>
              录入方式：
              {
                bulkEntryModeLabel[
                  payload.bulk_entry_mode ?? BulkWalletEntryMode.quantity
                ]
              }
            </Text>
            <Text>购买单价：{payload.purchase_unit_price} 分/积点</Text>
            <Text>退款结算单价：{payload.refund_unit_price} 分/积点</Text>
            <Text>实付金额：{formatAmount(amount)}</Text>
            {byAmount ? (
              <Text>到账积点按充值金额 ÷ 购买单价向上取整。</Text>
            ) : null}
          </>
        ) : null}
        <Text>外部交易号：{payload.external_payment_no}</Text>
      </Flex>
    </Modal>
  )
}
